define(function(require) {

    const PROD_SERVER_URL = "https://infogeo.education.gouv.qc.ca",
          DEV_SERVER_URL = "https://carto48dev.education.gouv.qc.ca",
          SERVER = "PROD", //document.location.origin === PROD_SERVER_URL ? "PROD" : "DEV",
          QUERY_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/PUBLIC_QUERY_SERVICES/GPServer",
          SW_MEES_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/DonneesOuvertes/SW_MEES/FeatureServer",
          CARTOVISTA_DATA_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/public/data",
          NETWORK_ANALYST_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/NETWORK_ANALYST_SERVICES/GPServer",
          LOGGER_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/LOGGER_SERVICES/GPServer",
          GEOCODER_MSP_URL = "https://geoegl.msp.gouv.qc.ca/apis/icherche/geocode";

    return {
        APP_NAME: "mfa",
        URLS: {
            LOGGER: {
                LOG_CLIENT_ERROR: LOGGER_SERVICES_URL + "/LogClientError/execute"
            },
            QUERY_LAYERS: {
                GEO09E34_GDUNO_ORG_IMM_FRANCO: SW_MEES_SERVICES_URL + "/3/query",
                GEO09E34_GDUNO_ORG_IMM_ANGLO: SW_MEES_SERVICES_URL + "/5/query",
                GEO09E34_GDUNO_ORG_IMM_STATUT: SW_MEES_SERVICES_URL + "/7/query",
                GEO09E01_CS_FRA_GEN: CARTOVISTA_DATA_URL + "/GEO09E01_CS_FRA_GEN.json",
                GEO09E01_CS_FRA: QUERY_SERVICES_URL + "/Query_GEO09E01_CS_FRA/execute",
                GEO09E02_CS_ANG_GEN: CARTOVISTA_DATA_URL + "/GEO09E02_CS_ANG_GEN.json",
                GEO09E02_CS_ANG: QUERY_SERVICES_URL + "/Query_GEO09E02_CS_ANG/execute",
                GEO09E03_CS_STA_GEN: CARTOVISTA_DATA_URL + "/GEO09E03_CS_STA_GEN.json",
                GEO09E03_CS_STA: QUERY_SERVICES_URL + "/Query_GEO09E03_CS_STA/execute",
                GEO09E04_MUNCP_GEN: CARTOVISTA_DATA_URL + "/GEO09E04_MUNCP_GEN.json",
                GEO09E04_MUNCP: QUERY_SERVICES_URL + "/Query_GEO09E04_MUNCP/execute",
                GEO09E17_ARRND: CARTOVISTA_DATA_URL + "/GEO09E17_ARRND.json",
                GEO09E05_MRC_GEN: CARTOVISTA_DATA_URL + "/GEO09E05_MRC_GEN.json",
                GEO09E05_MRC: QUERY_SERVICES_URL + "/Query_GEO09E05_MRC/execute",
                GEO09E06_REG_ADM_GEN: CARTOVISTA_DATA_URL + "/GEO09E06_REG_ADM_GEN.json",
                GEO09E06_REG_ADM: QUERY_SERVICES_URL + "/Query_GEO09E06_REG_ADM/execute",
            },
            NETWORK_ANALYST: {
                SERVICE_AREAS: NETWORK_ANALYST_SERVICES_URL + "/Service_Areas/execute",
            },
            SEARCH_VIEW: {
                GEOCODER_CP: GEOCODER_MSP_URL,
                GEOCODER_ADRS: GEOCODER_MSP_URL,
            }
        },
        LAYERS : {
            SERVICE_AREAS: require("configs/layers/SERVICE_AREAS"),
            GEO09E34_GDUNO_ORG_IMM_FRANCO : require("configs/layers/GEO09E34_GDUNO_ORG_IMM_FRANCO"),
            GEO09E34_GDUNO_ORG_IMM_ANGLO : require("configs/layers/GEO09E34_GDUNO_ORG_IMM_ANGLO"),
            GEO09E34_GDUNO_ORG_IMM_STATUT : require("configs/layers/GEO09E34_GDUNO_ORG_IMM_STATUT"),
            GEO09E17_ARRND : require("configs/layers/GEO09E17_ARRND"),
            GEO09E04_MUNCP_GEN : require("configs/layers/GEO09E04_MUNCP_GEN"),
            GEO09E03_CS_STA_GEN : require("configs/layers/GEO09E03_CS_STA_GEN"),
            GEO09E01_CS_FRA_GEN : require("configs/layers/GEO09E01_CS_FRA_GEN"),
            GEO09E02_CS_ANG_GEN : require("configs/layers/GEO09E02_CS_ANG_GEN"),
            GEO09E05_MRC_GEN : require("configs/layers/GEO09E05_MRC_GEN"),
            GEO09E06_REG_ADM_GEN : require("configs/layers/GEO09E06_REG_ADM_GEN"),
            GEOCODER_CP : require("configs/layers/GEOCODER_CP"),
            GEOCODER_ADRS: require("configs/layers/GEOCODER_ADRS")
        },
        THEMESETS_ELEMENTS : {
            OCF_THEME : require("configs/themeSetsElements/OCF_THEME"),
            SGEE_THEME : require("configs/themeSetsElements/SGEE_THEME"),
            TAUX_BC: require("configs/themeSetsElements/TAUX_BC"),
            TAUX_BC_COUR: require("configs/themeSetsElements/TAUX_BC_COUR"),
            TAUX_BC_PROJ: require("configs/themeSetsElements/TAUX_BC_PROJ"),
            RESEAU_PPS : require("configs/themeSetsElements/RESEAU_PPS"),
            TOUS_THEME : require("configs/themeSetsElements/TOUS_THEME")
        },
        APP_TOOLS: {
            CLIENT_ERRORS_LOGGER: {
                ENABLE: true
            },
        },
        MAP_TOOLS: {
            BASEMAP_TOGGLE: [
                {ID: "carte", BASEMAPLAYERS_IDS: ["Fondstuiles_5"], INITIAL: true, COPYRIGHTS_IMAGERIE: false},
                {ID: "hybride", BASEMAPLAYERS_IDS: ["Fondstuiles_5", "Fondstuiles_6"], INITIAL: false, COPYRIGHTS_IMAGERIE: true},
                {ID: "imagerie", BASEMAPLAYERS_IDS: ["Fondstuiles_6"], INITIAL: false, COPYRIGHTS_IMAGERIE: true}
            ]
        },
        PANELS: {
            SERVICE_AREAS: require("configs/panels/ServiceAreasConfig")
        },
        MAP: {
            ID: "map1"
        },
        DEBUG: SERVER === "DEV" ? true : false
    };
});
